import _ from 'lodash';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import CustomerInfo from '../Customer/Index';
import ProfileList from '../Profile/ProfileList';
import RecentProfile from '../Profile/RecentProfile/Index';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCustomerId: '',
    };
  }

  componentDidUpdate() {
    if (window.location.href.split('/').includes('customer')) {
      if (this.state.selectedCustomerId !== window.location.href.split('/')[5]) {
        this.setState({ selectedCustomerId: window.location.href.split('/')[5] });
      }
    } else if (!_.isNull(this.state.selectedCustomerId)) {
      this.setState({ ...this.state, selectedCustomerId: null });
    }
  }

  getRightSideComponent() {
    const selectedCustomerName =
      !_.isEmpty(this.props.allCustomers) &&
      this.props.allCustomers.filter(customer => customer.id.toString() === window.location.href.split('/')[5])[0];
    var customerName = !_.isEmpty(selectedCustomerName) ? selectedCustomerName.customerName : '';
    if (_.isEmpty(this.state.selectedCustomerId)) {
      return <RecentProfile />;
    } else {
      return <ProfileList selectedCustomerId={this.state.selectedCustomerId} title={customerName} />;
    }
  }

  render() {
    if (this.props.menu.items.length > 2) {
      if (this.props.menu.items[1].children.length >= 2) {
        this.props.dashboardMenuSet();
      }
    }

    return (
      <Row>
        <Col xl={6} sm={12} md={12} style={{ padding: 0 }}>
          <CustomerInfo selectedCustomerId={this.state.selectedCustomerId} />
        </Col>
        <Col xl={6} sm={12} md={12} style={{ padding: 0 }}>
          {this.getRightSideComponent()}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => {
  return {
    allCustomers: state.customers.customers,
    menu: state.menu,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    dashboardMenuSet: () => dispatch({ type: 'DASHBOARD' }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
